export default __webpack_public_path__ + "assets/archive-project-list.2961bc93.png";